export class AppError {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public originalError?: any) {}
}
